import { ReactNode, useEffect, useState } from "react";
import "./DetailsPageWrapper.scss";
import BackArrow from "../../../../utils/Images/BackArrow";
import {
  capitalizeFirstLetter,
  removeJobDetailsData,
  scrollWindowTop,
} from "../../../../utils/Common/Constant";
import { useTranslation } from "react-i18next";
import Footer from "../../../../components/Footer/Footer";
import { AssessmentButton, Bullets, showToast } from "ui-components";
import Header from "../../../../components/Assessment/Header/Header";
import FileUpload from "./SidebarTab/FileUpload/FileUpload";
import { useNavigate } from "react-router-dom";
import { getSessionStorageItem } from "../../../../utils/SessionStorageMethod/getSessionStorageItem";
import { updateJobStatus } from "../../../../service/CvScanning/CvScanning";
import UploadIcon from "../../../../utils/Images/UploadIcon";
import { JobScreensEnums } from "../../../../utils/Enums/JobScreensEnums";
interface DetailsPagesProps {
  jobDetails: any;
  onFilesUploaded?: any;
  fileUploadData?: any;
  setFileProgressList?: any;
  fileProgressList?: any;
  children?: ReactNode; // Accept children as a prop
}

const DetailsPageWrapper: React.FC<DetailsPagesProps> = ({
  onFilesUploaded,
  fileUploadData,
  setFileProgressList,
  fileProgressList,
  children,
  jobDetails,
}) => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const navigate = useNavigate();
  const [assessmentDetail, setAssessmentDetail] = useState<any>({});
  const [loading, setLoading] = useState<any>(false);
  const params = new URLSearchParams(location.search);
  const atParam = params.get("at");
  useEffect(() => {
    setAssessmentDetail(jobDetails);
  }, [jobDetails?.jobId]);
  const handleCloseJob = async () => {
    setLoading(true);
    const updateJobRes = await updateJobStatus({
      jobId: jobDetails?.jobId,
      status: "Closed",
    });
    if (updateJobRes?.data?.status === 200) {
      setLoading(false);
      showToast(updateJobRes?.data?.customMessage, "success");
    }
  };
  useEffect(() => {
    scrollWindowTop();
  }, []);
  const handleEditJob = () => {
    removeJobDetailsData();
    navigate(
      `/${currentLanguage}/job/create-job?jobId=${assessmentDetail?.jobId}`,
    );
  };
  return (
    <>
      <Header />
      <div className="detailsPages container-fluid minHeight100 jobModuleStyle">
        <div className="row">
          <div className="col-md-12">
            <div className="skillsNameWrapper">
              <div className="arrowTitle">
                <div
                  className="backArrow"
                  onClick={() =>
                    navigate(
                      `/${currentLanguage}/jobs?page=${getSessionStorageItem("jobListPage") ?? 1}`,
                    )
                  }
                >
                  <BackArrow />
                </div>
                <h3>
                  {assessmentDetail?.title
                    ? capitalizeFirstLetter(assessmentDetail?.title)
                    : "-"}
                </h3>
              </div>
              <div className="d-flex gap-2">
                {assessmentDetail?.status === "Active" ? (
                  <div className="d-flex gap-3 wrapBtns">
                    {atParam === JobScreensEnums.TAB_JOB_DETAILS && (
                      <AssessmentButton
                        className="lightBtn"
                        onClick={handleEditJob}
                      >
                        {t("RESUME.EDIT_JOB")}
                      </AssessmentButton>
                    )}
                    {(atParam === JobScreensEnums.TAB_SELF ||
                      atParam === JobScreensEnums.TAB_APPLICATIONS ||
                      atParam === JobScreensEnums.TAB_SOURCE) && (
                      <FileUpload
                        onFilesUploaded={onFilesUploaded}
                        fileUploadData={fileUploadData}
                        setFileProgressList={setFileProgressList}
                        fileProgressList={fileProgressList}
                        isChildrenUsed={true}
                      >
                        <AssessmentButton className="lightBtn d-flex align-items-center gap-2 uploadBtn">
                          {t("RESUME.SCANNING_UPLOAD_CV")}
                          <UploadIcon color={"var(--primary-black)"} />
                        </AssessmentButton>
                      </FileUpload>
                    )}
                  </div>
                ) : assessmentDetail?.notAssessment ? (
                  <div className="assessmentCloseStatus">
                    <span>{t("GENERAL.ASSESSMENT_CLOSED")}</span>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className="skillsNames">
              <div className="bulletSec">
                {assessmentDetail?.jobSkills?.map((item: any, ind: number) => {
                  return (
                    <div key={ind}>
                      <Bullets
                        skillName={capitalizeFirstLetter(item?.skillName)}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        {children && <div className="custom-children-section">{children}</div>}{" "}
        {atParam === JobScreensEnums.TAB_JOB_DETAILS && (
          <div className="closeJob">
            <AssessmentButton
              disabled={loading}
              className="lightBtn"
              onClick={() => handleCloseJob()}
            >
              {t("RESUME.SCANNING_CLOSE_JOB")}
            </AssessmentButton>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default DetailsPageWrapper;
